import { render, staticRenderFns } from "./CreatorTable.vue?vue&type=template&id=70d7921c&"
import script from "./CreatorTable.vue?vue&type=script&lang=js&"
export * from "./CreatorTable.vue?vue&type=script&lang=js&"
import style0 from "./CreatorTable.vue?vue&type=style&index=0&id=70d7921c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports